import { Model, RailsFormat } from "./model";

export class Role extends Model implements RailsFormat {
  constructor(
    public name: string = null,
    public code: string = null,
  ) {
    super()
  }

  public static clone(obj: any) {
    const role = new this()

    if (obj.code) { role.code = obj.code }
    if (obj.name) { role.name = obj.name }

    return role
  }

  public serializeForRails(): any {
    const response = Object.assign({}, this)
    return response
  }
}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/models/role.ts